module.exports = __webpack_public_path__ + "static/media/main3.57301b82.png";